import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Form from 'saur_ui_library/src/Atoms/Input/Form/Form';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import { LocalStorage } from '../utils/localStorage';
import { createGlobalStyle } from 'styled-components';
import {
  distanceMapping,
  formCoefficientType,
  midDistance,
  transferType,
  transferTypeMapping,
} from '../utils/Interface';
import { TransferCoefficientApi } from '../utils/api';
import RadioListComponent from '../components/common/component/RadioListComponent';
import SaveButton from '../components/common/SaveButton';
import { getParameters, handleOnSubmit } from '../utils/helpers/apiHelper';
import { loaderDataComponent } from '../utils/helper';

const TransferCoefficient = () => {
  const [dataList, setDataList] = React.useState<any>();
  const [form, setForm] = React.useState<formCoefficientType>({
    id: dataList?.id,
    rating: dataList?.rating,
    mainInstallCode: dataList?.mainInstallCode,
    transferType: dataList?.transferType,
    distance: dataList?.distance,
  });
  const [loading, setLoading] = useState(false);
  const [, setParamName] = useState('');
  const [selectedTransfer, setSelectedTransfer] = useState<number>();
  const [selectedDistance, setSelectedDistance] = useState<number>();
  const [code, setCode] = useState(window.sessionStorage.getItem('Code'));

  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);

  //useEffects
  useEffect(() => {
    const localName = LocalStorage.prName.get();
    if (localName !== null) {
      setParamName(localName.toString());
    }
    setCode(window.sessionStorage.getItem('Code'));
    getParameters(setLoading, setDataList, TransferCoefficientApi.getCoefficientRating(code));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //useEffects
  useEffect(() => {
    const notAllowedKeys = ['mainInstallCode', 'rating'];
    let newDataList = { ...dataList };
    if (newDataList) {
      Object.keys(newDataList).forEach((key) => {
        if (notAllowedKeys.includes(key)) delete newDataList[key];
      });
    }
    setForm(newDataList);

    //Fill selected radioList with a number
    const currentTransfer = transferTypeMapping[dataList?.transferType];
    if (currentTransfer !== undefined) {
      setSelectedTransfer(currentTransfer);
    }

    //Fill selected radioList with a number
    const currentDistance = distanceMapping[dataList?.distance];
    if (currentDistance !== undefined) {
      setSelectedDistance(currentDistance);
    }
  }, [dataList]);

  return (
    <Card className='transfer-container'>
      <Styles />
      <Toast id='toast-success' ref={toastSucess} />
      <Toast id='toast-error' ref={toastError} />
      <Form
        className='form-style'
        onSubmit={() =>
          handleOnSubmit(
            setLoading,
            TransferCoefficientApi.updateCoefficientRating(form,code),
            toastSucess,
            toastError,
            setDataList
          )
        }
      >
        <RadioListComponent
          className='radio-list'
          radioClassName='radioStyle'
          wordClassName='word-className'
          value='Quel est le type de transfert des effluents vers le milieu ?'
          selected={selectedTransfer}
          onChange={(v: any) => {
            setForm((oldValues) => {
              setSelectedTransfer(v.id);
              return { ...oldValues, transferType: v.label };
            });
          }}
          values={transferType}
        />
        <RadioListComponent
          className='radio-list'
          radioClassName='radioStyle'
          wordClassName='word-className'
          value='A quelle distance (en m) du milieu récepteur est situé le PR ?'
          selected={selectedDistance}
          onChange={(v: any) => {
            setForm((oldValues) => {
              setSelectedDistance(v.id);
              return { ...oldValues, distance: v.value };
            });
          }}
          values={midDistance}
        />

        <Container className='rectangle'>
          <Word
            className='note-style'
            variant='span'
            textStyle='normalBold'
            value={`Coef : ${dataList?.rating || 0}`}
          />
        </Container>
        {loaderDataComponent(loading, ` width: 28px;
          height: 28px;
          border: 5px solid #FFF;
          border-bottom-color: #243977;
          border-radius: 50%;
          display: inline-block;
          box-sizing: border-box;
          animation: rotation 1s linear infinite;`)}
        {loading === false && <SaveButton />}
      </Form>
    </Card>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
    .transfer-container{
        display: flex;
        justify-content: center;
        .form-style {
            display: flex;
            flex-direction: column;
            margin: 20px 56px;
            justify-items: center;
            .saveButton{
                display: flex;
                align-items: center;
                margin: 30px;
             }
        }
        .radio-list {
            margin: 20px 0;
        }
        .radioStyle{
            display: flex;
            flex-direction: row;
            margin-top: 10px;
            P {
              font-size: 16px;
            }
          .radio-item{
            margin-left: 20px;
             }
          .radio-item:last-child {
            margin-bottom: auto !important;
             } 
         .word-className{
            font-size: 16px !important;
         }
        }
        .rectangle {
        margin-top: 30px 0;
        background-color: #FFE0B3;
        border-radius: 15px;
        width: 236px;
        height: 97px;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
            font-size: 20px !important;
        }
        .note-style {
            color: #333;
            color: #232323;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            font-size: 20px !important;
          }
          divusagenote .box {
            margin: calc(10vh - 20px) auto 0px !important;
          }
              }
    }
}`;

export default React.memo(TransferCoefficient);
